import type { ReactNode } from 'react'

export interface EmptyStateProps {
  title: string
  description: string
  icon?: ReactNode
  action?: ReactNode
}

/** Centered onboarding / empty-list card used across placeholder pages. */
export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-4 rounded-2xl border border-line bg-ground-2 px-8 py-16 text-center">
      {icon && <div className="text-ink-faint">{icon}</div>}
      <div className="flex flex-col gap-2">
        <h2 className="font-display text-display-m text-ink">{title}</h2>
        <p className="max-w-prose text-body text-ink-muted">{description}</p>
      </div>
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
